import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import slikaStavbe from '../assets/slika_stavbe.png';

export default function Home() {
  const { t } = useLanguage();
  const leadParagraphs = t.home.lead.split('\n\n').filter(Boolean);
  const leadIntro = leadParagraphs[0] || '';
  const titlePrefix = t.home.titlePrefix || t.home.title;
  const titleEmphasis = t.home.titleEmphasis;
  const trustItems = Array.isArray(t.home.trustItems) ? t.home.trustItems : [];

  return (
    <>
      <section className="hero">
        <div className="hero-grid">
          <div className="hero-content">
            <div className="hero-label">{t.home.heroLabel}</div>
            <h1>
              {titlePrefix}
              {titleEmphasis ? (
                <>
                  {' '}
                  <em>{titleEmphasis}</em>
                </>
              ) : null}
            </h1>
            <p className="hero-desc">{leadIntro}</p>
            <div className="hero-actions">
              <Link to="/kontakt" className="btn btn-primary">{t.home.ctaContact}</Link>
              <Link to="/podrocja-dela" className="btn btn-outline">{t.home.ctaPracticeAreas}</Link>
            </div>
          </div>

          <div className="hero-image">
            <div className="hero-image-main">
              <img src={slikaStavbe} alt="Poslovna stavba odvetniške pisarne" className="hero-building-image" />
            </div>
            <div className="hero-image-float">
              <div className="stat-value">{t.home.statValue}</div>
              <div className="stat-label">{t.home.statLabel}</div>
            </div>
          </div>
        </div>
      </section>

      {trustItems.length > 0 && (
        <section className="trust-bar">
          <div className="trust-inner">
            {trustItems.map((item) => (
              <div key={`${item.value}-${item.label}`} className="trust-item">
                <div className="trust-value">{item.value}</div>
                <div className="trust-label">{item.label}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="approach-section">
        <div className="section-header">
          <div className="section-label">{t.home.approachLabel}</div>
          <h2 className="section-title">{t.home.approachTitle}</h2>
          <p className="section-subtitle">{t.home.approachSubtitle}</p>
        </div>

        <div className="approach-grid">
          <div className="approach-steps">
            {t.home.approachSteps.map((step, idx) => (
              <div key={step.title} className="approach-step">
                <div className="step-num">{String(idx + 1).padStart(2, '0')}</div>
                <div className="step-content">
                  <h4>{step.title}</h4>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="approach-quote-card">
            <blockquote>{t.home.approachQuote}</blockquote>
            <cite>{t.home.approachQuoteCite}</cite>
          </div>
        </div>
      </section>

      <section className="emergency-section">
        <div className="emergency-card">
          <div>
            <div className="emergency-badge">{t.home.emergencyBadge}</div>
            <h2>{t.home.emergencyTitle}</h2>
            <p>{t.home.emergencyParagraph1}</p>
          </div>
          <div className="emergency-phone">
            <a href={`tel:${t.home.emergencyPhoneRaw}`}>{t.home.emergencyPhoneDisplay}</a>
            <span>{t.home.emergencyPhoneNote}</span>
          </div>
        </div>
      </section>
    </>
  );
}
